<!--图片上传-->
<template>
  <div>
    <el-upload style="display:flex;flex-direction: row-reverse;justify-content: flex-end;" :action="api.uploadFileUrl"
               :on-remove="handleRemove" accept=".doc,.docx,.xlsx,.xls,.ppt,.pptx,.pdf,.txt" :on-preview="Previewf"
               :before-upload="checkFileType" list-type="text" :file-list="photoList"
               :on-success="(res, file, fileList) => { handleSuccess(res, file, fileList) }"
               :on-change="(files, fileList) => { handleImageChange(fileList) }" :auto-upload="true" :headers="headers">
      <i slot="default" class="el-icon-plus"></i>
    </el-upload>

    <!--
    <el-image-viewer
      v-if="dialogVisible"
      :on-close="closeImgViewer"
      :url-list="dialogImageUrlList"/> -->
  </div>
</template>

<script>
import api from "@/api/projectApi";
import store from "@/store";

export default {
  name: 'photoUpload',
  props: {
    photoUrl: {
      type: [Array],
      require: true
    },
    index: {
      type: [Number],
      require: true
    }
  },

  computed: {
    api() {
      return api
    },
    headers: function () {
      const tenantId = store.getters.userInfo.tenantId
      return {
        'Authorization': "Bearer " + store.getters.access_token,
        'TENANT-ID': tenantId
      };
    }
  },

  components: {
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer')
  },

  data() {
    return {
      photoList: [],
      dialogImageUrlList: [],
      dialogVisible: false,
      picList: [],

    }
  },

  watch: {
    photoUrl: {
      handler(url) {
        if (url) {
          let list = []
          if (url !== null && url !== '' && url !== undefined) {
            // let name=this.photoList[0].name
            console.log(url, "name55555");
            this.photoList = url

            // list.push({url: url,name:name})
          }
          // this.photoList = list
          // console.log(this.photoList,"文本回显");

        } else {
          // this.photoList = []
        }
      },
      deep: true,
      immediate: false,
    },

    photoList: {
      handler(n) {
        if (n.length > 0) {
          console.log(this.photoList, n, "触发l此处");
          this.$emit('update:photoUrl', this.photoList)
        }
      },
      deep: true,
      immediate: false,
    },

  },


  methods: {
    checkFileType(file) {
      console.log(file.type, "jsUp上传前");

      // const fileName = file.name
      // const fileType = fileName.substring(fileName.lastIndexOf('.'))
      // jpeg,.png,.jpg,.bmp,.gif
      // if (
      //   fileType === '.doc' ||
      //   fileType === '.docx' ||
      //   fileType === '.xlsx' ||
      //   fileType === '.xls' ||
      //   fileType === '.txt'
      // ) {
      //   // 不处理
      // } else {
      //   this.$message.error(
      //     '不是,jpeg,.png,.jpg,.bmp,.gif文件,请上传正确的图片类型'
      //   )
      //   return false
      // }
    },

    handleRemove(file) {
      const newList = this.photoList.filter(item => item.uid !== file.uid);
      this.photoList = newList;
    },


    handleSuccess(res, file, fileList) {
      let url = res.data.url
      console.log(url, "photoUrl")
      let list = []
      if (url !== null && url !== '' && url !== undefined) {
        this.photoList.push({ name: file.name, url: url })
      }
      // this.photoList = list
      console.log(this.photoList, "上传的文件");
    },


    handleImageChange(fileList) {
      // this.photoList = fileList
    },


    // handlePictureCardPreview(file) {
    //   this.dialogImageUrlList = [file.url]
    //   this.dialogVisible = true
    // },
    Previewf(file) {
      console.log(file, "打开");
      // let url=file.type
      let url = file.url
      let name = file.name

      const x = new XMLHttpRequest()
      x.open('GET', url, true)
      x.responseType = 'blob'
      x.onload = function () {
        const url = window.URL.createObjectURL(x.response)
        const a = document.createElement('a')
        a.href = url
        a.download = name
        a.click()
      }
      x.send()


      // window.open(url,'_blank');
    },


    closeImgViewer() {
      this.dialogVisible = false
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep.table-detail .el-upload--picture-card {
  // margin-top: 10px;
  // width: 80px;
  height: 40px;
  line-height: 50px !important;
}

::v-deep .el-upload-list .el-upload-list__item {
  display: inline-block;
  width: 165px;
  height: 40px;
  margin-right: 14px;
  border-radius: 2px;
  padding: 0 !important;
  border-color: #e8e8e8;
  margin-top: 0;
  margin-bottom: 10px;
  background-color: #e9e9e9;
}

::v-deep .el-upload-list .el-upload-list__item .el-upload-list__item-thumbnail {
  // width: 80px;
  height: 40px;
  padding: 0 !important;
  position: inherit;
  cursor: pointer;
}

::v-deep.el-upload-list__item.is-success .el-upload-list__item-status-label {
  display: none !important;
}

::v-deep .el-upload {
  display: block;
  height: 40px;
  width: 40px;
  border-radius: 5px;
  line-height: 40px;
  background-color: #fbfdff;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  font-size: 21px;
}
</style>
